import { deleteRequest, patchRequest, putRequest } from '../utils'

interface PlanPutRequest {
  title: string
  comment: string
  file: File
}

interface PlanPatchRequest {
  guid: string
  title: string
  comment: string
  tags: string[]
  file: File
}

export const savePlan: RequestTypeVariable = {
  getKey: (projectId: string) => ['savePlan', projectId],
  request: async (id: string, data: PlanPutRequest): Promise<Plan> => {
    const formData = new FormData()
    formData.append('file', data.file)
    formData.append('title', data.title)
    formData.append('comment', data.comment || '')

    const { data: result } = await putRequest<Plan>({
      url: `/projects/${id}/plans`,
      data: formData,
    })

    return result as Plan
  },
}

export const deletePlan: RequestTypeVariable = {
  getKey: (projectId: string) => ['deletePlan', projectId],
  request: async (id: string, guid: string): Promise<void> => {
    await deleteRequest({
      url: `/projects/${id}/plans/${guid}`,
    })
  },
}

export const updatePlan: RequestTypeVariable = {
  getKey: (projectId: string) => ['updatePlan', projectId],
  request: async (id: string, data: PlanPatchRequest): Promise<Plan> => {
    const formData = new FormData()
    formData.append('file', data.file)
    formData.append('title', data.title)
    formData.append('comment', data.comment || '')
    data.tags.forEach(tag => formData.append('tags', tag))

    const { data: result } = await patchRequest<Plan>({
      url: `/projects/${id}/plans/${data.guid}`,
      data: formData,
    })

    return result as Plan
  },
}
